(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('Comite', Comite);

  function Comite($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/comite/:id', {id: '@_id'});
  }
}());
